import profileImage from "../assets/portrait-hilman.jpg?as=webp";

const heroData = {
  greeting: "Hi, I'm",
  name: "Hilman Fikry",
  typingStrings: ["Software Engineer.", "Web Developer.", "Data Engineer."],
  bio: `I'm a software and data engineer, passionate about building scalable
applications and robust data pipelines with clean architecture and
DevOps practices.`,
  profileImage: profileImage,
  profileAlt: "A portrait of Hilman Fikry",
  resumeCta: "Download resume",
  resumeLink:
    "https://1drv.ms/f/c/06767bee76cede9f/IgAYQ_J4fEmXTaKjAlJff_mOAT7xSpQp1qjDxL5EFs_c30U?e=YkfNNA",
  contactCta: "Contact me",
  contactLink: "#contact",
};

export default heroData;
